import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { BillingRoutes } from "./BillingRoutes";

export const BillingLayout = () => (
    <SwitchRoute routes={BillingRoutes}/>
);